"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "brandsByRetailerId", {
    enumerable: true,
    get: ()=>brandsByRetailerId
});
const _graphqlRequest = require("graphql-request");
const brandsByRetailerId = (0, _graphqlRequest.gql)`
    query brandsByRetailerId(
        $retailerId: ID!
        $menuType: MenuType!
    ){
        menu(
            retailerId: $retailerId
            menuType: $menuType
        ){
            brands {
                imageUrl
                description
                name
                id
            }
        }
    }
`;
